import { lazy } from "react";

const Dashboard = lazy(() => import("./Dashboard"));

export default Dashboard;
